const wechat = () => import(/* webpackChunkName: "wechat" */ '@/views/wechat/index.vue');
const wechatLiuhe = () => import(/* webpackChunkName: "wechat" */ '@/views/wechat/liuhe.vue');

const wechatRoute = [
    {
        path: '/wechat',
        name: 'wechat',
        component: wechat,
        meta:{
            needLogin: true
        }
      
    },
    {
        path: '/wechat/liuhe',
        name: 'wechatLiuhe',
        component: wechatLiuhe,
        meta:{
            needLogin: true
        }
      
    },

    

]

export default wechatRoute
